
const initial_users  ={
    user_data:{

    },
}



export default initial_users